import React from "react";
import { API_JAVA } from "../libs/data-access/constant";
import { useDirectusApi } from "../libs/data-access";
import { showToast } from "../utils/utility";

export default function useReport() {

  const [loading, setLoading] = React.useState(false);
  const { fetchDirectDataBlob } = useDirectusApi();
  // const handleDownloadBaseLineReport = () => {
  //   axios({
  //     method: "get",
  //     url: `${API}custom/download-patient-report`,
  //     responseType: "arraybuffer",
  //   })
  //     .then((response) => {
  //       const blob = new Blob([response.data], {
  //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       });
  //       const link = document.createElement("a");
  //       link.href = window.URL.createObjectURL(blob);
  //       link.download = "patient_report.xlsx";
  //       link.click();

  //       showToast({
  //         type: "success",
  //         message: "Report Downloaded",
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error downloading report", error);
  //       showToast({
  //         type: "error",
  //         message: "Error downloading report",
  //       });
  //     });
  // };


  const handleDownloadBaseLineReport = (
    centerId?: string,
    diseaseCategory?: "asymptomatic_gallstone" | "symptomatic_gallstone" | "gallbladder_cancer" | "non_gallstone_control"
  ) => {

    // Base URL
    let endPoint = `${API_JAVA}excelForFirstVisit`;

    // Add query parameters conditionally
    if (centerId && diseaseCategory) {
      endPoint += `?CenterId=${centerId}&diseaseCategory=${diseaseCategory}`;
    } else if (centerId) {
      endPoint += `?CenterId=${centerId}`;
    } else if (diseaseCategory) {
      endPoint += `?diseaseCategory=${diseaseCategory}`;
    }

    // Triggering download by opening the URL in a new window/tab
    window.open(endPoint, "_blank");
  };


  const handleDownloadFollowUpReport = (
    centerId?: string,
    diseaseCategory?: "asymptomatic_gallstone" | "symptomatic_gallstone" | "gallbladder_cancer" | "non_gallstone_control"
  ) => {

    // Base URL
    let endPoint = `${API_JAVA}excelForRepeatedVisit`;

    // Add query parameters conditionally
    if (centerId && diseaseCategory) {
      endPoint += `?CenterId=${centerId}&diseaseCategory=${diseaseCategory}`;
    } else if (centerId) {
      endPoint += `?CenterId=${centerId}`;
    } else if (diseaseCategory) {
      endPoint += `?diseaseCategory=${diseaseCategory}`;
    }

    // Triggering download by opening the URL in a new window/tab
    window.open(endPoint, "_blank");
  };

  const handleDownloadConsolidatedReport = (
    centerId?: string,
    diseaseCategory?: "asymptomatic_gallstone" | "symptomatic_gallstone" | "gallbladder_cancer" | "non_gallstone_control"
  ) => {

    // Base URL
    let endPoint = `${API_JAVA}excelForMultipleVisit`;

    // Add query parameters conditionally
    if (centerId && diseaseCategory) {
      endPoint += `?CenterId=${centerId}&diseaseCategory=${diseaseCategory}`;
    } else if (centerId) {
      endPoint += `?CenterId=${centerId}`;
    } else if (diseaseCategory) {
      endPoint += `?diseaseCategory=${diseaseCategory}`;
    }

    // Triggering download by opening the URL in a new window/tab
    window.open(endPoint, "_blank");
  };

  const handleDownloadAllReport = async (fileName?: string, diseaseCategory?: "asymptomatic_gallstone" | "symptomatic_gallstone" | "gallbladder_cancer" | "non_gallstone_control") => {
    setLoading(true);
    const resolvedFileName = fileName ?? "center-reports.xlsx";
    const url = diseaseCategory ? `custom/center-reports/excel?diseaseCategory=${diseaseCategory}` : "custom/center-reports/excel";
    const result = await fetchDirectDataBlob(
      url,
      resolvedFileName,
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );
    setLoading(false);
    if (result.isSuccess) {
      showToast({ type: "success", message: "Report Downloaded" });
    } else {
      showToast({ type: "error", message: result.message || "Error downloading report" });
    }
  }



  return {
    loading,
    handleDownloadBaseLineReport,
    handleDownloadFollowUpReport,
    handleDownloadConsolidatedReport,
    handleDownloadAllReport
  };
}
